// src/context/StoreContext.js
import React, { createContext, useState, useContext } from 'react';

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openProductModal = (product) => {
    setSelectedProduct(product);
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
  };

  return (
    <StoreContext.Provider value={{ selectedProduct, openProductModal, closeProductModal }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  return useContext(StoreContext);
}